import { render } from "./App.vue?vue&type=template&id=b2870646&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b2870646&lang=css"

import exportComponent from "C:\\Users\\Vintz\\Documents\\Github\\SiteCV\\site-cv-main-page\\site-cv-main-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__